import axios from "axios";

export const state = {
    patientbalances: [],
};

export const getters = {
    patientbalances: state => state.patientbalances,
};

export const mutations = {
    setBalances(state, newValue) {
        state.patientbalances = newValue
    },
};

export const actions = {
    fetchBalances({ commit }) {
        axios.get('/patientbalances').then(res => {
            commit('setBalances', res.data.savings);
        })
    },
};
